<dx-popup
  [width]="400"
  [height]="450"
  [showTitle]="true"
  class="vehicles-tracker-icons-selector-popup"
  [title]="'Icons ' + item?.name"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [(visible)]="visible">
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Enregistrer',
            onClick: save
        }">
  </dxi-toolbar-item>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Annuler',
            onClick: close
        }">
  </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">

    <dx-drop-down-box
      displayExpr="name"
      placeholder="Select a value..."
      [showClearButton]="true"
      [dataSource]="ds"
      [showDropDownButton]="true"
      fieldTemplate="fieldTemplate">

      <div *dxTemplate="let data of 'fieldTemplate'">
        <div class="custom-item flex flex-row items-center">
      <span style="width: 18px; height: 18px"
            class="block border border-solid border-gray-700 mx-2"
            [ngStyle]="{backgroundColor: data?.color || '#ffffff'}"></span>
          <dx-text-box
            [value]="data?.path_str"
            placeholder="Sélectionnez une cultutre"
            [readOnly]="true">
          </dx-text-box>
        </div>
      </div>

      <div *dxTemplate="let data of 'content'">
        <dx-data-grid
          [dataSource]="ds"
          (onRowInserting)="onRowInserting($event)"
          [showBorders]="false"
          [showRowLines]="true"
          [height]="350"
          [columnAutoWidth]="true">

          <dxo-selection mode="single"></dxo-selection>
          <dxo-scrolling mode="virtual"></dxo-scrolling>
          <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
          <dxo-editing mode="popup"
                       [allowDeleting]="true"
                       [allowAdding]="true"
                       [allowUpdating]="true">
            <dxo-popup width="300" height="400"></dxo-popup>
            <dxo-form colCount="1"></dxo-form>
          </dxo-editing>
          <dxi-column
            dataField="icon"
            caption="Icone"
            [formItem]="{label: {visible: false}}"
            editCellTemplate="iconUploader"
            cellTemplate="iconTemplate">

            <div *dxTemplate="let cellInfo of 'iconUploader';">
              <app-vehicle-icon-uploader (valueChange)="cellInfo.setValue($event)"
                                         [value]="cellInfo.value"></app-vehicle-icon-uploader>
            </div>

            <div *dxTemplate="let cellInfo of 'iconTemplate';">
              <div style="width: 36px; height: 36px;"
                   class="text-center bg-gray-100 self-center rounded-full h-9 w-9 m-2 relative">
                <img alt="Icone" [src]="safeUrl(cellInfo.value)"/>
              </div>
            </div>
          </dxi-column>
          <dxi-column dataField="name" dataType="string" caption="Nom">
            <dxi-validation-rule type="required"></dxi-validation-rule>
          </dxi-column>
          <dxo-search-panel
            [visible]="true"
            [width]="240"></dxo-search-panel>
        </dx-data-grid>
      </div>
    </dx-drop-down-box>
  </div>
</dx-popup>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{ of: '.vehicles-tracker-icons-selector-popup' }"
  [visible]="loadIndicatorVisible"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
